module.exports = __webpack_public_path__ + "img/icon5.160a17ef.webp";